import { components } from "./components/index";
import { events } from "./events/index";


const PremiumScheduleAttachmentsSection = {
  components,
  events
};

export { PremiumScheduleAttachmentsSection };